import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getDashboardData,
  getLeaderboardData,
} from "./../features/cutomers/customerSlice";
import { Table } from "antd";

const Dashboard = () => {
  const dispatch = useDispatch();
  const { dashboardData, leaderboardData, total, isLoading } = useSelector(
    (state) => state.customer
  );
  // const [searchQuery, setSearchQuery] = useState("");

  // const handleInputChange = (event) => {
  //   setSearchQuery(event.target.value);
  // };

  // // Handle key down events on search
  // const handleKeyDown = (event) => {
  //   if (event.key === "Enter") {
  //     setPagination({
  //       ...pagination,
  //       current: 1,
  //       key: searchQuery,
  //     });
  //   }
  // };

  useEffect(() => {
    dispatch(getDashboardData());
  }, [dispatch]);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 1000,
    key: "",
    status: "",
  });

  const handleTableChange = (pagination) => {
    setPagination({
      ...pagination,
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      total: total,
    }));
  }, [total]);

  useEffect(() => {
    const { current, pageSize, key, status } = pagination;
    const skip = (current - 1) * pageSize;
    dispatch(
      getLeaderboardData({ limit: pageSize, skip, key: key, status: status })
    );
  }, [
    dispatch,
    pagination.pageSize,
    pagination.key,
    pagination.status,
    pagination,
  ]);

  const columns = [
    {
      title: "Name",
      key: "user_id",
      render: (record) => {
        return (
          <div>
            <p>
              {record.user.first_name} {record.user.last_name}
            </p>
          </div>
        );
      },
    },
    {
      title: "Points",
      dataIndex: "points",
      render: (points) => {
        return (
          <div>
            <p>
              {points}
            </p>
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <label style={{ fontSize: "16px", color: "#2b7949", marginBottom: "15px", fontWeight: 500 }}>App Statistics</label>
      <div className="row g-3">
        {/* All cards in one row for desktop */}
        <div className="col-6 col-md-4 col-lg-2 mb-3">
          <div
            className="card bg-white p-3 shadow-sm"
            style={{ borderRadius: "15px", border:"1px solid #ffffff" }}
          >
            <div>
              <div className="d-flex justify-content-between align-items-center mb-1">
                <p
                  className="text-muted mb-0"
                  style={{ fontSize: "12px", color: "#888" }}
                >
                  Total Users
                </p>
                <img src="group.png" alt="" />
              </div>
              <h2
                className="mb-0 fw-bold"
                style={{ color: "#1a3c34", fontSize: "28px" }}
              >
                {dashboardData.total_users || 0}
              </h2>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-4 col-lg-2 mb-3">
          <div
            className="card bg-white p-3 shadow-sm"
            style={{ borderRadius: "15px", border:"1px solid #ffffff" }}
          >
            <div>
              <div className="d-flex justify-content-between align-items-center mb-1">
                <p
                  className="text-muted mb-0"
                  style={{ fontSize: "12px", color: "#888" }}
                >
                  Total Entries
                </p>
                <img src="group.png" alt="" />
              </div>
              <h2
                className="mb-0 fw-bold"
                style={{ color: "#1a3c34", fontSize: "28px" }}
              >
                {dashboardData.total_entries || 0}
              </h2>
            </div>
          </div>
        </div>

        <div className="col-6 col-md-4 col-lg-2 mb-3">
          <div
            className="card bg-white p-3 shadow-sm"
            style={{ borderRadius: "15px", border:"1px solid #ffffff" }}
          >
            <div>
              <div className="d-flex justify-content-between align-items-center mb-1">
                <p
                  className="text-muted mb-0"
                  style={{ fontSize: "12px", color: "#888" }}
                >
                  Daily Sign Ups
                </p>
                <img src="how_to_reg.png" alt="" />
              </div>
              <h2
                className="mb-0 fw-bold"
                style={{ color: "#1a3c34", fontSize: "28px" }}
              >
                {dashboardData.daily_sign_ups || 0}
              </h2>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-4 col-lg-2 mb-3">
          <div
            className="card bg-white p-3 shadow-sm"
            style={{ borderRadius: "15px", border:"1px solid #ffffff" }}
          >
            <div>
              <div className="d-flex justify-content-between align-items-center mb-1">
                <p
                  className="text-muted mb-0"
                  style={{ fontSize: "12px", color: "#888" }}
                >
                  Daily Shot Entries
                </p>
                <img src="sports_golf.png" alt="" />
              </div>
              <h2
                className="mb-0 fw-bold"
                style={{ color: "#1a3c34", fontSize: "28px" }}
              >
                {dashboardData.daily_shot_entries || 0}
              </h2>
            </div>
          </div>
        </div>

        <div className="col-6 col-md-4 col-lg-2 mb-3">
          <div
            className="card bg-white p-3 shadow-sm"
            style={{ borderRadius: "15px", border:"1px solid #ffffff" }}
          >
            <div>
              <div className="d-flex justify-content-between align-items-center mb-1">
                <p
                  className="text-muted mb-0"
                  style={{ fontSize: "12px", color: "#888" }}
                >
                  Daily Transactions
                </p>
                <img src="currency_exchange.png" alt="" />
              </div>
              <h2
                className="mb-0 fw-bold"
                style={{ color: "#1a3c34", fontSize: "28px" }}
              >
                {dashboardData.daily_transactions || 0}
              </h2>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-4 col-lg-2 mb-3">
          <div
            className="card bg-white p-3 shadow-sm"
            style={{ borderRadius: "15px", border:"1px solid #ffffff" }}
          >
            <div>
              <div className="d-flex justify-content-between align-items-center mb-1">
                <p
                  className="text-muted mb-0"
                  style={{ fontSize: "12px", color: "#888" }}
                >
                  Daily Transactions
                </p>
                <img src="currency_exchange.png" alt="" />
              </div>
              <h2
                className="mb-0 fw-bold"
                style={{ color: "#1a3c34", fontSize: "28px" }}
              >
                {dashboardData.daily_transactions_amount || 0}
              </h2>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-4 col-lg-2 mb-3">
          <div
            className="card bg-white p-3 shadow-sm"
            style={{ borderRadius: "15px", border:"1px solid #ffffff" }}
          >
            <div>
              <div className="d-flex justify-content-between align-items-center mb-1">
                <p
                  className="text-muted mb-0"
                  style={{ fontSize: "12px", color: "#888" }}
                >
                  Daily Shot Clicks
                </p>
                <img src="currency_exchange.png" alt="" />
              </div>
              <h2
                className="mb-0 fw-bold"
                style={{ color: "#1a3c34", fontSize: "28px" }}
              >
                {dashboardData.daily_shot_clicks || 0}
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="row-space-between">
        <label style={{ fontSize: "16px", color: "#2b7949", fontWeight: 500 }}>Leaderboard</label>
        {/* <div className="my-row">
          <div className="mr-5">
            <Input
              placeholder="Search users"
              value={searchQuery}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              prefix={<IoSearchOutline className="fs-4" />}
            />
          </div>
        </div> */}
      </div>
      <div className="mt-4">
        <Table
          columns={columns}
          dataSource={leaderboardData.leaderboard}
          rowKey={(record) => record._id}
          onChange={handleTableChange}
          pagination={pagination}
          loading={isLoading}
        />
      </div>
    </div>
  );
};

export default Dashboard;
